/*
 *
 * TemplatePreviewPage actions
 *
 */

import {
  FETCH_TEMPLATE_PREVIEW,
  FETCH_TEMPLATE_PREVIEW_SUCCESS,
  FETCH_TEMPLATE_PREVIEW_ERROR,
  CREATE_FROM_TEMPLATE,
  CREATE_FROM_TEMPLATE_SUCCESS,
  CREATE_FROM_TEMPLATE_ERROR,
} from './constants';

export function fetchTemplatePreview(templateId) {
  return {
    type: FETCH_TEMPLATE_PREVIEW,
    templateId,
  };
}

export function fetchTemplatePreviewSuccess(data) {
  return {
    type: FETCH_TEMPLATE_PREVIEW_SUCCESS,
    data,
  };
}

export function fetchTemplatePreviewError(error) {
  return {
    type: FETCH_TEMPLATE_PREVIEW_ERROR,
    error,
  };
}

export function createFromTemplate({
  surveyName,
  surveyType,
  templateId,
  storeObject,
  defaultRecurrence,
  selectedCountry,
  totalCompletes,
  peeqCategoryType,
}) {
  return {
    type: CREATE_FROM_TEMPLATE,
    surveyName,
    surveyType,
    templateId,
    storeObject,
    defaultRecurrence,
    selectedCountry,
    totalCompletes,
    peeqCategoryType,
  };
}

export function createFromTemplateSuccess() {
  return {
    type: CREATE_FROM_TEMPLATE_SUCCESS,
  };
}

export function createFromTemplateError(error) {
  return {
    type: CREATE_FROM_TEMPLATE_ERROR,
    error,
  };
}
